module.exports = {"title":"Week 7: Milestones","body":"<p>We focus on accomplishing our milestones and ensure that it is demonstrable.  The GUI task is still in progress, but well on its way.</p>\n"}


//////////////////
// WEBPACK FOOTER
// ./process/week-7/index.md
// module id = 498
// module chunks = 0